import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Volunteers} from "./volunteer.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VolunteerService {

  private collectionName = 'volunteers';

  constructor(private firestore: AngularFirestore) {}

  getVolunteers(): Observable<Volunteers[]> {
    return this.firestore.collection<Volunteers>(this.collectionName).valueChanges({ idField: 'id' });
  }

  getVolunteerById(id: any): Observable<Volunteers | undefined> {
    return this.firestore.collection(this.collectionName).doc<Volunteers>(id).valueChanges({ idField: 'id' });
  }

  addVolunteer(volunteer: Volunteers) {
    return this.firestore.collection(this.collectionName).add(volunteer);
  }

  updateVolunteer(id: string, volunteer: Volunteers) {
    return this.firestore.collection(this.collectionName).doc(id).update(volunteer);
  }

  deleteVolunteer(id: string) {
    return this.firestore.collection(this.collectionName).doc(id).delete();
  }
}
